import "../../App.css";
import Sidebar from "../../components/Sidebar";
import "../../styles/login.css";
import { withRouter } from "react-router-dom";
import React, { useState, useEffect } from "react";
import Table from "../Table";
import UserTab from "../UserTab";
import Parametros from "../Parametros";
import CurrentUser from "../CurrentUser";
function Moneda(props) {
  const { history } = props;
  const [MonedaStateUpdate, setMonedaStateUpdate] = useState([]);
  const [MonedaState, setMonedaState] = useState([]);
  // eslint-disable-next-line
  const [usuario, setUsuario] = useState(CurrentUser.user);
  const [update, setUpdate] = useState(false);

  const [formularioUpdate, setformularioUpdate] = useState({});
  const [paginacionState, setPaginacionState] = useState({
    limit: 5,
    skip: 1,
  });

  useEffect(() => {
    async function llamadaApi() {
      let response = await fetch(
        Parametros.urlApi + "Currency/?skip=0&limit=100&is_mantenedor=true",
        {
          headers: {
            Authorization: "Bearer " + usuario.key,
            Accept: "application/json",
            "Content-Type": "application/json",
            Origin: "https://d1tl5p9wrfnj29.cloudfront.net/",
          },
        }
      );
      if (response.status === 200 || response.status === 201) {
        let responseJson = await response.json();

        let responseJsonUpdate = JSON.stringify(responseJson);
        let responseJsonstate = JSON.stringify(responseJson);
        setMonedaState(JSON.parse(responseJsonUpdate));
        setMonedaStateUpdate(JSON.parse(responseJsonstate));
      } else if (response.status === Parametros.loginTokenExcept) {
        alert(Parametros.loginTokenExceptMessage);
        history.push({
          pathname: "/",
        });
      }
    }
    llamadaApi();
  }, [update, usuario, history]);
  const [formularioState, setFormularioState] = useState({
    friendlycode: "",
    full_name: "",
    isocode: "",
  });
  const [editable, setEditable] = useState({
    id: "",
  });
  let handleStageForm = (event) => {
    setFormularioState({
      ...formularioState,
      [event.target.name]: event.target.value,
    });
  };

  let crearMoneda = async (event) => {
    event.preventDefault();
    if (usuario.permisos.indexOf("Crear") > -1) {
      event.preventDefault();
      if (window.confirm("¿Esta seguro que deseas agregar este elemento?")) {
        let response = await fetch(Parametros.post + "Currency/", {
          method: "POST",
          body: JSON.stringify(formularioState),
          headers: {
            Authorization: "Bearer " + usuario.key,
            Accept: "application/json",
            "Content-Type": "application/json",
            Origin: Parametros.url,
          },
        });

        let responseJson = await response.json();

        if (response.status === 200 || response.status === 201) {
          setUpdate(!update);
          alert("ok");
          document.getElementById("formularioBusqueda").reset();
        } else if (response.status === Parametros.loginTokenExcept) {
          alert(Parametros.loginTokenExceptMessage);
          history.push({
            pathname: "/",
          });
        } else {
          alert(responseJson.detail);
          setMonedaState(JSON.parse(JSON.stringify(MonedaStateUpdate)));
        }
      } else {
        // Do nothing!
        setEditable({});
        // setpersonaEmpresaState(JSON.parse(JSON.stringify(personaEmpresaStateUpdate)))
      }
    } else {
      alert(usuario.crear);
    }
  };
  // let eliminarElemento = async (index, item) => {
  //
  //     // setetapaStateUpdate(nuevoObjeto)

  //     if (usuario.permisos.indexOf("Eliminar") > -1) {
  //         if (window.confirm('¿Esta seguro que deseas elminar este elemento?')) {
  //             // aqui deberia ir el delete segun response eliminar de la lista de react

  //
  //             let response = await fetch(Parametros.urlApi + "Currency/" + item.currency_id,
  //                 {
  //                     method: 'DELETE',
  //                     headers: {
  //                         'Authorization': "Bearer " + usuario.key,
  //                         'Accept': 'application/json',
  //                         'Content-Type': 'application/json',
  //                         'Origin': 'https://d1tl5p9wrfnj29.cloudfront.net/'
  //                     },
  //                 }

  //             )
  //             let responseJson = await response.json()
  //

  //             if (response.status === 200 || response.status === 201) {
  //                 alert(responseJson.detail)
  //                 setUpdate(!update)
  //                 setEditable({})
  //             } else if (response.status === Parametros.loginTokenExcept) {
  //                 alert(Parametros.loginTokenExceptMessage)
  //                 history.push({
  //                     pathname: '/'
  //                 })
  //             } else {
  //
  //                 alert(responseJson.detail)
  //                 setMonedaState(JSON.parse(JSON.stringify(MonedaStateUpdate)))
  //             }
  //         } else {
  //             // Do nothing!
  //             // setEditable({})
  //             // setMonedaState(JSON.parse(JSON.stringify(MonedaStateUpdate)))
  //         }

  //     } else {
  //         alert(usuario.eliminar)
  //     }

  // }
  let MonedaHandleChange = (index, e) => {
    const name = e.target.getAttribute("name");
    const value = e.currentTarget.value
      ? e.currentTarget.value
      : e.currentTarget.innerText;

    let newList = MonedaState;
    newList[index][name] = value;
    setMonedaState(JSON.parse(JSON.stringify(newList)));

    let estadoUpdate = formularioUpdate;
    estadoUpdate[name] = value;

    setformularioUpdate(JSON.parse(JSON.stringify(estadoUpdate)));
  };
  let confirmarEdicion = async (item) => {
    // setetapaStateUpdate(nuevoObjeto)

    if (usuario.permisos.indexOf("Editar") > -1) {
      if (window.confirm("¿Esta seguro que deseas editar este elemento?")) {
        // aqui deberia ir el delete segun response eliminar de la lista de react

        let response = await fetch(
          Parametros.urlApi + "Currency/" + parseInt(item.currency_id),
          {
            method: "PUT",
            headers: {
              Authorization: "Bearer " + usuario.key,
              Accept: "application/json",
              "Content-Type": "application/json",
              Origin: "https://d1tl5p9wrfnj29.cloudfront.net/",
            },
            body: JSON.stringify(formularioUpdate),
          }
        );

        let responseJson = await response.json();

        if (response.status === 200 || response.status === 201) {
          alert("se edito correctamente");
          setUpdate(!update);
          setEditable({});
        } else if (response.status === Parametros.loginTokenExcept) {
          alert(Parametros.loginTokenExceptMessage);
          history.push({
            pathname: "/",
          });
        } else {
          alert(responseJson.detail);
          setEditable({});
          setMonedaState(JSON.parse(JSON.stringify(MonedaStateUpdate)));
        }
      } else {
        // Do nothing!
        setEditable({});
        setMonedaState(JSON.parse(JSON.stringify(MonedaStateUpdate)));
      }
    } else {
      alert(usuario.editar);
    }
  };

  let editar = (id) => {
    setMonedaState(JSON.parse(JSON.stringify(MonedaStateUpdate)));
    setEditable(id);
    setformularioUpdate({});
  };
  let cancelarEdicion = async (item) => {
    setEditable({});
    setMonedaState(JSON.parse(JSON.stringify(MonedaStateUpdate)));
  };

  return (
    <div className="App">
      <Sidebar tipo="2"></Sidebar>
      <br />
      <div className="container">
        <UserTab nombre={"Moneda"}></UserTab>
        <form id="formularioBusqueda" onSubmit={crearMoneda}>
          <div className="col-md-4">
            <h5>Sigla moneda</h5>
            <input
              onChange={handleStageForm}
              name="friendlycode"
              required
              className="form-control"
            ></input>
          </div>
          <div className="col-md-4">
            <h5>Denominación</h5>
            <input
              onChange={handleStageForm}
              name="full_name"
              required
              className="form-control"
            ></input>
          </div>
          <div className="col-md-4">
            <h5>Código ISO</h5>
            <input
              onChange={handleStageForm}
              name="isocode"
              required
              className="form-control"
            ></input>
          </div>
          <div className="col-md-4">
            <br />
            <button
              type="submit"
              value="Submit"
              style={{ margin: "14px 0px" }}
              id="btnBuscar"
              className="form-control button brEdit btn-primary"
            >
              Agregar nuevo
            </button>
          </div>
        </form>

        <div
          className="col-md-12 table-responsive"
          style={{ height: 300, width: "100%" }}
        >
          <Table
            type={1}
            paginationBelow={true}
            paginas={Math.max(
              1,
              Math.ceil(MonedaState.length / paginacionState.limit)
            )}
            paginadorState={paginacionState}
            setPaginadoor={setPaginacionState}
            elementos={["Sigla moneda", "Denominación", "Código ISO"]}
          ></Table>

          <table className="table table-bordered" id="myTable">
            <Table
              type={2}
              elementos={["Sigla moneda", "Denominación", "Código ISO"]}
            ></Table>

            {usuario.permisos.indexOf("Ver") > -1 ? (
              <tbody className="ajusteTabladata">
                {MonedaState.slice(
                  (paginacionState.skip - 1) * paginacionState.limit,
                  (paginacionState.skip - 1) * paginacionState.limit +
                    paginacionState.limit
                ).map((item, displayIndex) => {
                  const index =
                    (paginacionState.skip - 1) * paginacionState.limit +
                    displayIndex;
                  return (
                    <tr key={item.currency_id}>
                      {editable === item.currency_id ? (
                        <>
                          <td>{item.currency_id}</td>
                          <td>
                            <input
                              value={item.friendlycode}
                              name="friendlycode"
                              onChange={(event) => {
                                MonedaHandleChange(index, event);
                              }}
                              className="form-control"
                            ></input>
                          </td>
                          <td>
                            <input
                              value={item.full_name}
                              name="full_name"
                              onChange={(event) => {
                                MonedaHandleChange(index, event);
                              }}
                              className="form-control"
                            ></input>
                          </td>
                          <td>
                            <input
                              value={item.isocode}
                              name="isocode"
                              onChange={(event) => {
                                MonedaHandleChange(index, event);
                              }}
                              className="form-control"
                            ></input>
                          </td>
                          <td>
                            <abbr title="Confirmar Edición">
                              <span
                                style={{ cursor: "pointer" }}
                                onClick={() => {
                                  confirmarEdicion(item);
                                }}
                                className="glyphicon glyphicon glyphicon-ok"
                              >
                                {" "}
                              </span>
                            </abbr>
                            <abbr title="Cancelar Edición">
                              <span
                                style={{ cursor: "pointer" }}
                                onClick={() => {
                                  cancelarEdicion(item);
                                }}
                                className="glyphicon glyphicon-share-alt"
                              ></span>
                            </abbr>
                          </td>
                        </>
                      ) : (
                        <>
                          <td>{item.currency_id}</td>
                          <td>{item.friendlycode} </td>
                          <td>{item.full_name} </td>
                          <td>{item.isocode} </td>
                          <td>
                            <abbr title="Editar Elemento">
                              <span
                                style={{ cursor: "pointer" }}
                                onClick={() => {
                                  editar(item.currency_id);
                                }}
                                className="glyphicon glyphicon-pencil"
                              >
                                {" "}
                              </span>
                            </abbr>
                            {/* <abbr title="Eliminar Elemento"><span style={{ cursor: "pointer" }} onClick={() => { eliminarElemento(index, item) }} className='glyphicon glyphicon-remove'></span></abbr> */}
                          </td>
                        </>
                      )}
                    </tr>
                  );
                })}
              </tbody>
            ) : (
              <tbody>
                <td>{usuario.ver} </td>
              </tbody>
            )}
          </table>
          <Table
            type={3}
            paginas={Math.max(
              1,
              Math.ceil(MonedaState.length / paginacionState.limit)
            )}
            paginadorState={paginacionState}
            setPaginadoor={setPaginacionState}
          />
          {!usuario.permisos.indexOf("Ver") < -1 && usuario.ver}
        </div>
      </div>
    </div>
  );
}

export default withRouter(Moneda);
